import { OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { useMerchantPosContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/contexts/MerchantPosContext';
import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import { RelationOptions } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/constants/RelationOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface ContactDataFormProps extends FormGridOptions {}

export const ContactDataForm = ({ fieldVariant, fullWidth = false, direction }: ContactDataFormProps) => {
  const { selectedRole } = useMerchantPosContext();

  return (
    <FormSectionWrapper titleTid="CONTACT_DATA">
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction}>
        <TextFormField name={'email'} label={'EMAIL'} fieldVariant={fieldVariant} />
        <PhoneFormDoubleField fieldVariant={fieldVariant} />
        {selectedRole !== OnboardingDetailsRole.BORROWER && (
          <SelectFormField
            name={'relation'}
            label={'RELATION'}
            selectOptions={RelationOptions}
            fieldVariant={fieldVariant}
          />
        )}
      </FormGridContainer>
    </FormSectionWrapper>
  );
};
